export default __webpack_public_path__ + "media/images/11-88b9367fed65897f66039abbed7cf855.jpg";